module.exports = __webpack_public_path__ + "03_mole.01775b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer2/03_mole.png
// module id = 9Slg
// module chunks = 0